const brandHk = {
  brand: {
    添加品牌WhatsApp了解最新优惠:
      '添加品牌<img src="https://ricepon.oss-cn-hongkong.aliyuncs.com//h5/172620942457196c293beRicepon.png" />WhatsApp，瞭解最新優惠',
    前往添加: "前往添加",
    更换地址: "更換地址",
    自取: "自取",
    外送: "外送",
    会员二维码: "會員二維碼",
    优惠券: "優惠券({X})",
    邀请有礼: "邀請有禮",
    积分换礼: "積分換禮",
    此等级需购买: "此等級需購買",
    会员卡说明: "會員卡說明",
    当前等级: "當前等級",
    立即购买XY: "立即購買 {X}({Y})",
    查看等级特权: "查看等級特權",
    暂不支持购买: "暫不支持購買!",
    查看更多: "查看更多",
    折扣优惠: "折扣優惠",
    零售价: "零售價",
    团购促销: "團購促銷",
    人气王: "人氣王",
    回头客X: "回頭客 {X}",
    半年售X: "半年售 {X}",
    团购详情: "團購詳情",
    购买须知: "購買須知",
    立即抢购: "立即搶購",
    请选择数量: "請選擇數量",
    免预约: "免預約",
    周一到周日可用: "週一到週日可用",
    支付方式: "支付方式",
    商品总价: "商品總價",
    优惠共减: "優惠共減",
    提交订单: "提交訂單",
    X人餐: "{X}人餐",
    提交成功: "提交成功!",
    品牌门店: "品牌門店",
    壽司海鮮: "壽司/海鮮",
    人均X: "{X}/人均",
    查看更多店铺X: "查看更多店鋪({X})",
    分享至: "分享至",
    取消: "取消",
    Facebook: "Facebook",
    Instagram: "Instagram",
    WhatsApp: "WhatsApp",
    复制链接: "複製連結",
    链接已复制: "連結已複製",
    复制失败: "複製失敗",
    累计售X: "纍計售 {X}",
    抢购: "搶購",
    AI评分描述: "評分由AI通過參考第三方平臺對此餐廳的評分進行綜合計算，飯糰Ricepon不對此結果負責，請食客仔細甄選~",
    餐厅类型X: "{X}",
    人均X: "{X}/人均",
    营业时间: "營業時間",
    距您Xm: "距您{X}",
    导航: "導航",
    电话: "電話",
    外送: "外送",
    自取: "自取",
    标签X: "標籤 {X}",
    团购标题: "# 團購",
    餐厅简介: "餐廳簡介",
    营业中: "營業中",
    休息中: "休息中",
    繁忙中: "繁忙中",
    服务未开启: "服務未開啟",
    memberCode: "會員碼",
    points: "積分",
    pointsAction: "兌好禮 查明細",
    coupon: "優惠券",
    couponCount: "{X}張",
    viewCollectedCoupons: "查看已領卡券",
    noMore: "没有更多了",
    團購券: "團購券",
    餐飲券: "餐飲券",
    storeAddressPlaceholder: "請輸入門店地址",
    opening: "營業中",
    restaurantAddressUnset: "未設定餐廳地址",
    placeOrder: "落單",
    distanceMeter: "距離{X}米",
    chooseStoreByType: "選擇{X}門店",
    delivery: "外送",
    pickup: "自取",
    promoZone: "優惠專區",
    platformNotAvailable: "该平台暂未开放",
    soldOut: "售罄",
    onlinePayment: "在線支付",
    noOpenRestaurantOrderTip: "暫無營業中的餐廳!\n請稍後再落單~!",
    invalidPrice: "價格有誤,請勿下單!",
  },
};
export default brandHk;
